/* src/app/components/on-property-map/on-property-map.component.scss */
.map {
  width: 100%;
  height: 100%;
}
.message {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family:
    "Roboto",
    Tahoma,
    Helvetica,
    sans-serif;
  color: #AEAEAE;
  font-size: 31px;
  font-weight: 500;
  padding: 0 15px;
}
/*# sourceMappingURL=on-property-map.component.css.map */
